module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.bbb7b637.woff2";